import React from "react";
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  //   Divider
} from "@mui/material";

import {
  AccountCircle as AccountCircleIcon,
  PersonAdd,
  Settings,
  Logout,
} from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { showLoadingScreen } from "../../store/slices/loading";
// import { newNotification } from "../../store/slices/notification";
import { useSnackbar } from "notistack";


const UserMenuButton = ({ userData, logoutFunct }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isOpen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => {
    setAnchorEl(null);
  };
  const logout = () => {
    logoutFunct();
    handleClose();
  };


  return (
    <>
      <Button
        size="large"
        endIcon={<AccountCircleIcon />}
        onClick={handleClick}
      >
        {userData?.name || "Usuario " + userData?.id}
      </Button>
      <Menu
        anchorEl={anchorEl}
        // id="account-menu"
        open={isOpen}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => {
            enqueueSnackbar("This is a success message!", { variant: "success" })
          }}
        >
          <ListItemIcon>
            <PersonAdd fontSize="small" />
          </ListItemIcon>
          Add another account
        </MenuItem>
        <MenuItem
          // onClick={() => {
          //   dispatch(showLoadingScreen());
          // }}
        >
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem>
        <MenuItem
          onClick={() => {
            logout();
          }}
        >
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserMenuButton;
